import { fetchToken } from "../../common/FetchCookie";
import { ADMIN, BASE_URL, JOBS } from "../../common/URLs";


const API_BASE_URL = `${BASE_URL}/${ADMIN}/${JOBS}`; 

export const fetchAdminJobList = async (page) => {
  const url = `${API_BASE_URL}?page=${page}`; 
  try {
    const token = await fetchToken()

    const response = await fetch(url, { 
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    return error
  }
};